module.exports = __webpack_public_path__ + "img/copy.2a6ea0f2.svg";